// Mirror of types.ValidUserIdpDisplayName (common/types/user_idp.go). FormKit strips
// regex flags, so a `matches` rule loses `/u` and `\p{L}` stops matching letters.

export const USER_IDP_DISPLAY_NAME_MAX_LEN = 48;

const ALLOWED = /^[\p{L}\p{Nd}][\p{L}\p{Nd} \-_.&'()]*$/u;

export function validUserIdpDisplayName(value: unknown): boolean {
  if (typeof value !== "string" || value === "") return false;
  // Go caps bytes, so measure bytes here too.
  if (new TextEncoder().encode(value).length > USER_IDP_DISPLAY_NAME_MAX_LEN) return false;
  if (value.trim() !== value) return false;
  return ALLOWED.test(value);
}

// An install from before per-IdP names shows the generic single sign-on label, so seed
// the field with it and saving leaves the button as the users know it.
export function primaryIdpDisplayName(
  stored: string | null | undefined,
  configured: boolean,
  fallback: string,
): string {
  if (stored) return stored;
  return configured ? fallback : "";
}
